import { isApproved } from "../../../general/paper-state";
import { totalWithVat } from "./approveUsers/info-lines";

// Approval edits replace the articles, but older records retain their submission total.
// Match the theatre's details/print calculation without rewriting historical records.
export function paperListTotal(paper, companyId) {
  if (companyId !== 6 || !Array.isArray(paper.articles)) {
    return paper.totalPriceWithVat;
  }
  const total = totalWithVat(paper.articles);
  return Number.isFinite(total) ? total.toFixed(2) : paper.totalPriceWithVat;
}

export function canPrintPaper(paper, companyId) {
  return companyId !== 6 || isApproved(paper && paper.state);
}

export const PRINT_DISABLED_REASON = "Disponibil după aprobarea completă a referatului.";
